import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, Checkbox } from '@material-ui/core';
import _ from 'lodash';
import ApplicationTableRow from './ApplicationTableRow';
import ApplicationTableHeader from './ApplicationTableHeader';
import ValidationError from './ValidationError';

class SingleChoiceField extends React.Component {
  renderTable = (applications, categoriesEnabled, subcategoriesEnabled, input) => (
    <Table className="projects-table">
      <ApplicationTableHeader categoriesEnabled={categoriesEnabled} subcategoriesEnabled={subcategoriesEnabled} leftAction />
      <TableBody>
        {applications.map(application => (
          <ApplicationTableRow
            key={application.id}
            application={application}
            leftAction={<Checkbox
              checked={input.value && input.value === application.id ? true : false}
              onClick={() => {
                input.onChange(application.id);
                input.onBlur();
              }}
              value={application.id}
              color="primary"
              disabled={this.props.disabled}
            />}
            categoriesEnabled={categoriesEnabled}
            subcategoriesEnabled={subcategoriesEnabled}
          />)
        )}
      </TableBody>
    </Table>);

  render() {
    const { input, meta: { error, touched }, values, groupByDistricts, districts } = this.props;
    const categoriesEnabled = values.filter(a => a.category !== null).length > 0;
    const subcategoriesEnabled = values.filter(a => a.subcategory !== null).length > 0;

    return (
      <React.Fragment>
        <div className="box">
          <div className="col-sm-12">
            {groupByDistricts || categoriesEnabled
              ? _(values)
                .groupBy(x => groupByDistricts ? x.district : x.category)
                .map((value, key) => ({ key, applications: value}))
                .sortBy(x => groupByDistricts ? districts.indexOf(x.key) : ['key'])
                .value()
                .map(x => (
                  <div key={x.key} style={{ marginBottom: 30 }}>
                    <h3 className="category"><i className="fa fa-bookmark" /> <span>{groupByDistricts ? 'Obszar' : 'Kategoria'}</span> {x.key}</h3>
                    {this.renderTable(x.applications, groupByDistricts ? categoriesEnabled : false, subcategoriesEnabled, input)}
                  </div>))
            : this.renderTable(values, categoriesEnabled, subcategoriesEnabled, input)}
        </div>
      </div>
      {error && touched ? <ValidationError error={error} /> : null}
    </React.Fragment>);
  }
}

SingleChoiceField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  values: PropTypes.array.isRequired,
  groupByDistricts: PropTypes.bool.isRequired,
  districts: PropTypes.array,
};

export default SingleChoiceField;



// WEBPACK FOOTER //
// ./src/components/budget/types/SingleChoiceField.js